import { render, staticRenderFns } from "./UiCheckbox.vue?vue&type=template&id=2d2563fd&lang=pug&"
import script from "./UiCheckbox.vue?vue&type=script&lang=ts&"
export * from "./UiCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports